import React from 'react';
import RegisterForm from '../features/Auth/components/Register/RegisterForm';

function AuthPage() {
    return <RegisterForm/>;
}

export default AuthPage;